module.exports = __webpack_public_path__ + "static/media/packager_1.9634c307.ico";